import { render } from "./WebsiteVersionUpdate.vue?vue&type=template&id=9a6310f8&lang=true"
import script from "./WebsiteVersionUpdate.vue?vue&type=script&lang=js"
export * from "./WebsiteVersionUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__